module.exports = __webpack_public_path__ + "media/video.94f4ce74.mp4";